import React from 'react';
import { FormikRadioInput as Radio } from '@front-activerse/common-components';
import { useTranslator } from '@front-activerse/common-components';

export const Sex: React.FC = () => {
  const { t } = useTranslator();

  return (
    <>
      <h2 className="mb-4 title-large semi-bold">{t('app.biometric.gender.headline')}</h2>

      <Radio name="sex" value="female">
        {t('biometric.gender.optionFemale')}
      </Radio>

      <Radio name="sex" value="male">
        {t('biometric.gender.optionMale')}
      </Radio>
    </>
  );
};

export default Sex;
